import request from '../utils/request';
import { API_HELP_REQUEST, API_HELP_SUBMIT } from '../routes/api';

class HelpApi {
  static help_request(options, onSuccess, onError) {
    return request({ url: API_HELP_REQUEST, ...options }, onSuccess, onError);
  }

  static help_submit(options, onSuccess, onError) {
    return request(
      { url: API_HELP_SUBMIT, method: 'post', ...options },
      onSuccess,
      onError
    );
  }
}

export default HelpApi;
